(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smartnest-dimensional"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const init = (root = document) => {
    root.querySelectorAll('[data-sn-scene]').forEach(scene => {
      if (scene.dataset.ready) return;
      scene.dataset.ready = 'true';
      const stage = scene.querySelector('[data-sn-stage]');
      const toggle = scene.querySelector('[data-sn-motion-toggle]');
      let paused = false;
      let visible = true;
      let frame = 0;
      const update = () => {
        const enabled = scene.dataset.motion === 'true' && !reduced.matches;
        scene.dataset.running = String(enabled);
        scene.dataset.paused = String(paused || !visible || document.hidden);
        toggle.hidden = !enabled;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
        if (!enabled || paused) { stage.style.removeProperty('--sn-x'); stage.style.removeProperty('--sn-y'); }
      };
      toggle.addEventListener('click', () => { paused = !paused; update(); });
      stage.addEventListener('pointermove', event => {
        if (!fine.matches || reduced.matches || paused || scene.dataset.motion !== 'true') return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const rect = stage.getBoundingClientRect();
          stage.style.setProperty('--sn-x', `${((event.clientX - rect.left) / rect.width - .5) * 16}px`);
          stage.style.setProperty('--sn-y', `${((event.clientY - rect.top) / rect.height - .5) * 12}px`);
        });
      });
      stage.addEventListener('pointerleave', () => { cancelAnimationFrame(frame); stage.style.removeProperty('--sn-x'); stage.style.removeProperty('--sn-y'); });
      const onVisibility = () => update();
      reduced.addEventListener('change', update);
      document.addEventListener('visibilitychange', onVisibility);
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }) : null;
      observer?.observe(scene);
      const unload = event => {
        if (!event.target.contains(scene)) return;
        observer?.disconnect(); cancelAnimationFrame(frame);
        reduced.removeEventListener('change', update);
        document.removeEventListener('visibilitychange', onVisibility);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smartnest-noir-hero"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = (root = document) => root.querySelectorAll('[data-midnight-scroll]').forEach(wrapper => {
    if (wrapper.dataset.scrubReady) return;
    wrapper.dataset.scrubReady = 'true';
    const section = wrapper.querySelector('[data-midnight-video]');
    const video = wrapper.querySelector('video');
    const hint = wrapper.querySelector('[data-scroll-hint]');
    if (!video || !section) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    let targetTime = 0;
    let duration = 0;
    let failed = false;
    let disposed = false;
    video.muted = true;
    video.loop = false;
    video.autoplay = false;
    video.controls = false;
    video.pause();
    const hold = () => video.pause();
    const seek = () => {
      if (disposed || failed || !duration || video.seeking || video.readyState < 1) return;
      if (Math.abs(video.currentTime - targetTime) > .025) {
        try { video.currentTime = targetTime; } catch { return; }
      }
    };
    const update = () => {
      frame = 0;
      if (disposed || failed || reduced.matches || !duration) return;
      const rect = wrapper.getBoundingClientRect();
      const pinned = wrapper.dataset.scrubEnabled === 'true';
      const top = parseFloat(wrapper.style.getPropertyValue('--scrub-top')) || 0;
      const distance = pinned ? wrapper.offsetHeight - section.offsetHeight : Math.max(1,section.offsetHeight);
      const progress = Math.max(0,Math.min(1,(top - rect.top) / Math.max(1,distance)));
      wrapper.style.setProperty('--scrub-progress', String(progress));
      targetTime = progress * Math.max(0,duration - .04);
      seek();
    };
    const schedule = () => { if (!frame && !disposed) frame = requestAnimationFrame(update); };
    const configure = () => {
      const header = document.querySelector('header-component');
      const top = header ? header.getBoundingClientRect().height : 0;
      const height = Math.max(1,innerHeight - top);
      const enabled = !failed && !reduced.matches && !window.Shopify?.designMode && height >= 540;
      wrapper.style.setProperty('--scrub-top', `${top}px`);
      wrapper.style.setProperty('--scrub-height', `${height}px`);
      wrapper.style.setProperty('--scrub-distance', `${Math.round(innerHeight * 2)}px`);
      wrapper.dataset.scrubEnabled = String(enabled);
      if (hint) hint.hidden = reduced.matches || failed;
      video.pause();
      if (reduced.matches) { targetTime = 0; seek(); }
      else schedule();
    };
    const metadata = () => { duration = Number.isFinite(video.duration) ? video.duration : 0; configure(); };
    const onError = () => { failed = true; configure(); };
    video.addEventListener('play',hold);
    video.addEventListener('loadedmetadata',metadata);
    video.addEventListener('loadeddata',schedule);
    video.addEventListener('seeked',seek);
    video.addEventListener('error',onError);
    addEventListener('scroll',schedule,{passive:true});
    addEventListener('resize',configure,{passive:true});
    reduced.addEventListener('change',configure);
    const headerObserver = 'ResizeObserver' in window ? new ResizeObserver(configure) : null;
    const header = document.querySelector('header-component');
    if (header) headerObserver?.observe(header);
    const unload = event => {
      if (!event.target.contains(wrapper)) return;
      disposed = true; video.pause(); cancelAnimationFrame(frame); headerObserver?.disconnect();
      removeEventListener('scroll',schedule); removeEventListener('resize',configure);
      reduced.removeEventListener('change',configure);
      video.removeEventListener('play',hold); video.removeEventListener('loadedmetadata',metadata);
      video.removeEventListener('loadeddata',schedule); video.removeEventListener('seeked',seek); video.removeEventListener('error',onError);
      document.removeEventListener('shopify:section:unload',unload);
    };
    document.addEventListener('shopify:section:unload',unload);
    if (video.readyState >= 1) metadata(); else configure();
  });
  init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
